export class ComponentizedEquipment {
  assetId: number;
  equipId: number;
  ownerCode: string;
  ownerLabel: string;
  lotNum: string;
  description: string;
  comesWith: string;
  features: string;
  equipStatusId: number;
  auctionStatusId: number;
  saleGroupId: number;
  parentComponent: boolean;
  childComponent: boolean;
  deleted: boolean;
  brochurePhoto: string;

  public static fromJson(jsonObj: any): ComponentizedEquipment {
    return Object.assign(new ComponentizedEquipment(), jsonObj);
  }

  public setAuctionStatusId(auctionStatus: string): void {
    if (auctionStatus === 'New') {
      this.auctionStatusId = 0;
    } else if (auctionStatus === 'Preview') {
      this.auctionStatusId = 1;
    } else if (auctionStatus === 'Open') {
      this.auctionStatusId = 2;
    } else if (auctionStatus === 'Sold') {
      this.auctionStatusId = 3;
    } else if (auctionStatus === 'Unsold') {
      this.auctionStatusId = 4;
    }
  }
}
